import React, { useState } from 'react';
import Config from '../../env/config';
import './Modal.scss';

const Modal = ({ isOpen, widthClass, children, scrollbarHeight , closeModal , isClose=true }) => {
  const [lang] = useState(
    sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : "en"
  );

  const isArabicLang = lang === "ar";
  const CDN_URL = Config.CDN_URL;

  return (
    <>
      {isOpen && (
        <div className="modal-overlay">
          <div className={`modal-content modalbody-scrollbar ${scrollbarHeight} ${widthClass}`}>
          <div className={isArabicLang ? "HelpModalCloseButton-ar" : "HelpModalCloseButton"}>
                  {isClose ?<button onClick={closeModal}>
                    <img src={`${CDN_URL}close_fill_inc.webp`} 
                      alt="close"
                    />
                  </button>: false}
                </div>
            {children}
           
          </div>
          
        </div>
      )}
    </>
  );
};

export default Modal;

export const CustomModal =({ isOpen, closeModal, width ,handleSuccess, errorMsg ,isErrorModel}) => {
  const [lang] = useState(
    sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : "en"
  );

  const isArabicLang = lang === "ar";
  const CDN_URL = Config.CDN_URL;

  return (
    <>
      {isOpen && (
        <div className="modal-overlay">
          <div className={`modal-content modalbody-scrollbar ${width}`}>
            {isErrorModel ?<div className={isArabicLang ? "CloseButton-ar" : "CloseButton"}>
                <button onClick={closeModal}>
                    <img src={`${CDN_URL}close_fill_inc.webp`} alt="close" />
                  </button>
              </div>:null}
              <div className="ProposalConfirmModalFlx">
                <div className="proconfimg">
                  <img src={`${CDN_URL}proposal_cofrim_img.webp`} alt="Confirm Image" />
                </div>
                <div className="procnfmsg">
                  {errorMsg}
                </div>
                <div className="propconbtnsec">
                  <button className="ok-btn" onClick={handleSuccess}>OK</button>
                </div>
              </div>           
          </div>
          
        </div>
      )}
    </>
  );
};